import * as CONST from 'Reducers/Header/const'

/**
 * Set header search value
 * @returns Object
 */
export function headerSearchUpdate(headerSearch) {
  return {
    type: CONST.HEADER_SEARCH_UPDATE,
    headerSearch,
  }
}

/**
 * Reset header search value
 * @returns Object
 */
export function headerSearchReset() {
  return {
    type: CONST.HEADER_SEARCH_RESET,
  }
}



// WEBPACK FOOTER //
// ./src/Reducers/Header/actions.js